export default [
  { name: 'Hokkaidō', code: 'JP-01' },
  { name: 'Aomori', code: 'JP-02' },
  { name: 'Iwate', code: 'JP-03' },
  { name: 'Miyagi', code: 'JP-04' },
  { name: 'Akita', code: 'JP-05' },
  { name: 'Yamagata', code: 'JP-06' },
  { name: 'Fukushima', code: 'JP-07' },
  { name: 'Ibaraki', code: 'JP-08' },
  { name: 'Tochigi', code: 'JP-09' },
  { name: 'Gunma', code: 'JP-10' },
  { name: 'Saitama', code: 'JP-11' },
  { name: 'Chiba', code: 'JP-12' },
  { name: 'Tōkyō', code: 'JP-13' },
  { name: 'Kanagawa', code: 'JP-14' },
  { name: 'Niigata', code: 'JP-15' },
  { name: 'Toyama', code: 'JP-16' },
  { name: 'Ishikawa', code: 'JP-17' },
  { name: 'Fukui', code: 'JP-18' },
  { name: 'Yamanashi', code: 'JP-19' },
  { name: 'Nagano', code: 'JP-20' },
  { name: 'Gifu', code: 'JP-21' },
  { name: 'Shizuoka', code: 'JP-22' },
  { name: 'Aichi', code: 'JP-23' },
  { name: 'Mie', code: 'JP-24' },
  { name: 'Shiga', code: 'JP-25' },
  { name: 'Kyōto', code: 'JP-26' },
  { name: 'Ōsaka', code: 'JP-27' },
  { name: 'Hyōgo', code: 'JP-28' },
  { name: 'Nara', code: 'JP-29' },
  { name: 'Wakayama', code: 'JP-30' },
  { name: 'Tottori', code: 'JP-31' },
  { name: 'Shimane', code: 'JP-32' },
  { name: 'Okayama', code: 'JP-33' },
  { name: 'Hiroshima', code: 'JP-34' },
  { name: 'Yamaguchi', code: 'JP-35' },
  { name: 'Tokushima', code: 'JP-36' },
  { name: 'Kagawa', code: 'JP-37' },
  { name: 'Ehime', code: 'JP-38' },
  { name: 'Kōchi', code: 'JP-39' },
  { name: 'Fukuoka', code: 'JP-40' },
  { name: 'Saga', code: 'JP-41' },
  { name: 'Nagasaki', code: 'JP-42' },
  { name: 'Kumamoto', code: 'JP-43' },
  { name: 'Ōita', code: 'JP-44' },
  { name: 'Miyazaki', code: 'JP-45' },
  { name: 'Kagoshima', code: 'JP-46' },
  { name: 'Okinawa', code: 'JP-47' }
];
